"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPortalsTradeEstimate = exports.fetchPortalsTradeOrder = void 0;
const axios_1 = __importDefault(require("axios"));
const fetchPortalsTradeOrder = async ({ sender, inputToken, inputAmount, outputToken, slippageTolerancePercentage, partner, feePercentage, validate, swapperConfig, }) => {
    const url = `${swapperConfig.REACT_APP_PORTALS_BASE_URL}/v2/portal`;
    const params = new URLSearchParams({
        partner,
        sender,
        inputToken,
        inputAmount,
        outputToken,
        validate: validate.toString(),
    });
    if (slippageTolerancePercentage !== undefined) {
        params.append('slippageTolerancePercentage', slippageTolerancePercentage.toFixed(2)); // Portals API expects a string with at most 2 decimal places
    }
    if (feePercentage) {
        params.append('feePercentage', feePercentage.toString());
    }
    try {
        const response = await axios_1.default.get(url, { params });
        return response.data;
    }
    catch (error) {
        if (axios_1.default.isAxiosError(error)) {
            throw new Error(`Failed to fetch Portals trade order: ${error.message}`);
        }
        throw error;
    }
};
exports.fetchPortalsTradeOrder = fetchPortalsTradeOrder;
const fetchPortalsTradeEstimate = async ({ sender, inputToken, inputAmount, outputToken, slippageTolerancePercentage, swapperConfig, }) => {
    const url = `${swapperConfig.REACT_APP_PORTALS_BASE_URL}/v2/portal/estimate`;
    const params = new URLSearchParams({
        sender,
        inputToken,
        inputAmount,
        outputToken,
    });
    if (slippageTolerancePercentage !== undefined) {
        params.append('slippageTolerancePercentage', slippageTolerancePercentage.toFixed(2)); // Portals API expects a string with at most 2 decimal places
    }
    try {
        const response = await axios_1.default.get(url, { params });
        return response.data;
    }
    catch (error) {
        if (axios_1.default.isAxiosError(error)) {
            throw new Error(`Failed to fetch Portals trade estimate: ${error.message}`);
        }
        throw error;
    }
};
exports.fetchPortalsTradeEstimate = fetchPortalsTradeEstimate;
